export const MONTH = 'month' as const;
export const QUARTER = 'quarter' as const;
export const YEAR = 'year' as const;

export type TimePeriod = typeof MONTH | typeof QUARTER | typeof YEAR;

export interface DateRange {
  from: string;
  to: string;
}
